import { useEffect, useState } from 'react';

export const usePreviewWithProgress = (url: string) => {
  const [progress, setProgress] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchPreview = async () => {
      try {
        const response = await fetch(url);
        const contentLength = response.headers.get('content-length');

        if (!response.ok || !contentLength) {
          console.error('Failed to fetch preview or get content length');
          return;
        }

        const total = parseInt(contentLength, 10);
        let loaded = 0;

        const reader = response.body!.getReader();
        const chunks: Uint8Array[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (value) {
            chunks.push(value);
            loaded += value.length;
            const percent = Math.floor((loaded / total) * 100);
            if (isMounted) {
              setProgress(percent);
            }
          }
        }

        if (isMounted) {
          setLoading(false);
        }
      } catch (err) {
        console.error('Error loading preview:', err);
      }
    };

    fetchPreview();

    return () => {
      isMounted = false;
    };
  }, [url]);

  return { progress, loading };
};
